/**
 *
 * @param modulesArray
 * @returns {Array}
 */
export default function (modulesArray) {
  let modules = [];
  modulesArray.filter( module => modules.push(module.name) );
  return modules;
}


/** WEBPACK FOOTER **
 ** ./frontend/@/getModulesNames.helper.js
 **/